"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCommunityPoolSpendAmount = exports.transformSetSettlementPriceParams = exports.transfromSetMinGasPriceParams = exports.transfromSetMsgGasCostParams = exports.transfromSetTradingFlagParams = exports.transfromUpdatePoolParams = exports.transfromSetCommitmentCurveParams = exports.transfromSetRewardCurveParams = exports.transfromSetRewardsWeightsParams = exports.transfromUnlinkPoolParams = exports.transfromLinkPoolParams = exports.transfromSyncTokenParams = exports.transfromCreateTokenParams = exports.transfromCreateOracleParams = exports.AdminModule = void 0;
const CarbonSDK_1 = require("../CarbonSDK");
const tx_1 = require("../codec/cosmos/staking/v1beta1/tx");
const util_1 = require("../util");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const long_1 = __importDefault(require("long"));
const base_1 = __importDefault(require("./base"));
class AdminModule extends base_1.default {
    createOracle(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Oracle.MsgCreateOracle.fromPartial({
                creator: wallet.bech32Address,
                createOracleParams: transfromCreateOracleParams(params, wallet.bech32Address),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateOracle,
                value,
            }, opts);
        });
    }
    createToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgCreateToken.fromPartial({
                creator: wallet.bech32Address,
                createTokenParams: transfromCreateTokenParams(params, wallet.bech32Address),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateToken,
                value,
            }, opts);
        });
    }
    createTokens(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = params.map((param) => {
                const value = CarbonSDK_1.Carbon.Coin.MsgCreateToken.fromPartial({
                    creator: wallet.bech32Address,
                    createTokenParams: transfromCreateTokenParams(param, wallet.bech32Address),
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgCreateToken,
                    value,
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
    syncToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgSyncToken.fromPartial(transfromSyncTokenParams(params, wallet.bech32Address));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSyncToken,
                value,
            }, opts);
        });
    }
    bindToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgBindToken.fromPartial({
                creator: wallet.bech32Address,
                sourceDenom: params.sourceDenom,
                wrappedDenom: params.wrappedDenom,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgBindToken,
                value,
            }, opts);
        });
    }
    unbindToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgUnbindToken.fromPartial({
                creator: wallet.bech32Address,
                wrappedDenom: params.wrappedDenom,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUnbindToken,
                value,
            }, opts);
        });
    }
    updateToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgUpdateToken.fromPartial({
                updater: wallet.bech32Address,
                denom: params.denom,
                updateTokenParams: {
                    name: params.name,
                    symbol: params.symbol,
                    decimals: params.decimals,
                    isActive: params.isActive,
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateToken,
                value,
            }, opts);
        });
    }
    linkToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgLinkToken.fromPartial({
                creator: wallet.bech32Address,
                denom: params.denom,
                bridgeAddress: params.bridgeAddress,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgLinkToken,
                value,
            }, opts);
        });
    }
    createMarket(params, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Market.MsgCreateMarket.fromPartial({
                creator: wallet.bech32Address,
                marketType: params.marketType,
                base: params.base,
                quote: params.quote,
                currentBasePriceUsd: params.currentBasePriceUsd.shiftedBy(18).toString(10),
                currentQuotePriceUsd: params.currentQuotePriceUsd.shiftedBy(18).toString(10),
                indexOracleId: (_a = params.indexOracleId) !== null && _a !== void 0 ? _a : "",
                expiryTime: (_b = params.expiryTime) !== null && _b !== void 0 ? _b : new Date(0),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateMarket,
                value,
            }, opts);
        });
    }
    createMarkets(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = params.map((param) => {
                var _a;
                const value = CarbonSDK_1.Carbon.Market.MsgCreateMarket.fromPartial(Object.assign({ creator: wallet.bech32Address, marketType: param.marketType, base: param.base, quote: param.quote, currentBasePriceUsd: param.currentBasePriceUsd.toString(10), currentQuotePriceUsd: param.currentQuotePriceUsd.toString(10), indexOracleId: (_a = param.indexOracleId) !== null && _a !== void 0 ? _a : "" }, (param.expiryTime && { expiryTime: param.expiryTime })));
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgCreateMarket,
                    value,
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
    setRewardsWeights(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Liquiditypool.MsgSetRewardsWeights.fromPartial({
                creator: wallet.bech32Address,
                setRewardsWeightsParams: transfromSetRewardsWeightsParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetRewardsWeights,
                value,
            }, opts);
        });
    }
    setRewardCurve(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Liquiditypool.MsgSetRewardCurve.fromPartial({
                creator: wallet.bech32Address,
                setRewardCurveParams: transfromSetRewardCurveParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetRewardCurve,
                value,
            }, opts);
        });
    }
    setCommitmentCurve(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Liquiditypool.MsgSetCommitmentCurve.fromPartial({
                creator: wallet.bech32Address,
                setCommitmentCurveParams: transfromSetCommitmentCurveParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetCommitmentCurve,
                value,
            }, opts);
        });
    }
    updatePool(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Liquiditypool.MsgUpdatePool.fromPartial({
                creator: wallet.bech32Address,
                updatePoolParams: transfromUpdatePoolParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdatePool,
                value,
            }, opts);
        });
    }
    setTradingFlag(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Order.MsgSetTradingFlag.fromPartial(transfromSetTradingFlagParams(params, wallet.bech32Address));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetTradingFlag,
                value,
            }, opts);
        });
    }
    setMsgFee() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("deprecated");
        });
    }
    setMsgGasCost(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Fee.MsgSetGasCost.fromPartial({
                creator: wallet.bech32Address,
                setGasCostParams: transfromSetMsgGasCostParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetGasCost,
                value,
            }, opts);
        });
    }
    setMinGasPrice(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Fee.MsgSetMinGasPrice.fromPartial({
                creator: wallet.bech32Address,
                setMinGasPriceParams: transfromSetMinGasPriceParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetMinGasPrice,
                value,
            }, opts);
        });
    }
    removeMsgGasCost(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Fee.MsgRemoveGasCost.fromPartial({
                creator: wallet.bech32Address,
                msgType: params.msgType,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRemoveGasCost,
                value,
            }, opts);
        });
    }
    removeMinGasPrice(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Fee.MsgRemoveMinGasPrice.fromPartial({
                creator: wallet.bech32Address,
                denom: params.denom,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRemoveMinGasPrice,
                value,
            }, opts);
        });
    }
    createValidator(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgCreateValidator.fromPartial(Object.assign(Object.assign({ delegatorAddress: params.delegatorAddress, validatorAddress: params.validatorAddress, minSelfDelegation: params.minSelfDelegation.toString(10), description: params.description, pubkey: params.pubkey }, (params.commission && {
                commission: {
                    rate: params.commission.rate.shiftedBy(18).toString(10),
                    maxRate: params.commission.maxRate.shiftedBy(18).toString(10),
                    maxChangeRate: params.commission.maxChangeRate.shiftedBy(18).toString(10),
                },
            })), (params.value && {
                value: {
                    denom: params.value.denom,
                    amount: params.value.amount.toString(10),
                },
            })));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateValidator,
                value,
            }, opts);
        });
    }
    editValidator(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgEditValidator.fromPartial({
                description: params.description,
                validatorAddress: params.validatorAddress,
                commissionRate: params.commissionRate.shiftedBy(18).toString(10),
                minSelfDelegation: params.minSelfDelegation.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgEditValidator,
                value,
            }, opts);
        });
    }
    authorizeBridge(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgAuthorizeBridge.fromPartial({
                creator: wallet.bech32Address,
                bridgeId: new long_1.default(params.bridgeId),
                chainId: new long_1.default(params.chainId),
                chainName: params.chainName,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgAuthorizeBridge,
                value,
            }, opts);
        });
    }
    deauthorizeBridge(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgDeauthorizeBridge.fromPartial({
                initiator: wallet.bech32Address,
                bridgeId: new long_1.default(params.bridgeId),
                chainId: new long_1.default(params.chainId),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgDeauthorizeBridge,
                value,
            }, opts);
        });
    }
    addRateStrategy(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgAddRateStrategy.fromPartial({
                creator: wallet.bech32Address,
                rateStrategyParams: {
                    name: params.rateStrategy.name,
                    optimalUsage: params.rateStrategy.optimalUsage.toString(10),
                    baseVariableBorrowRate: params.rateStrategy.baseVariableBorrowRate.toString(10),
                    variableRateSlope1: params.rateStrategy.variableRateSlope1.toString(10),
                    variableRateSlope2: params.rateStrategy.variableRateSlope2.toString(10),
                    baseStableBorrowRate: params.rateStrategy.baseStableBorrowRate.toString(10),
                    stableRateSlope1: params.rateStrategy.stableRateSlope1.toString(10),
                    stableRateSlope2: params.rateStrategy.stableRateSlope2.toString(10),
                    optimalStableToTotalDebtRatio: params.rateStrategy.optimalStableToTotalDebtRatio.toString(10),
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgAddRateStrategy,
                value,
            }, opts);
        });
    }
    updateRateStrategy(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgUpdateRateStrategy.fromPartial({
                creator: wallet.bech32Address,
                rateStrategyParams: {
                    name: params.rateStrategy.name,
                    optimalUsage: params.rateStrategy.optimalUsage.toString(10),
                    baseVariableBorrowRate: params.rateStrategy.baseVariableBorrowRate.toString(10),
                    variableRateSlope1: params.rateStrategy.variableRateSlope1.toString(10),
                    variableRateSlope2: params.rateStrategy.variableRateSlope2.toString(10),
                    baseStableBorrowRate: params.rateStrategy.baseStableBorrowRate.toString(10),
                    stableRateSlope1: params.rateStrategy.stableRateSlope1.toString(10),
                    stableRateSlope2: params.rateStrategy.stableRateSlope2.toString(10),
                    optimalStableToTotalDebtRatio: params.rateStrategy.optimalStableToTotalDebtRatio.toString(10),
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateRateStrategy,
                value,
            }, opts);
        });
    }
    removeRateStrategy(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgRemoveRateStrategy.fromPartial({
                creator: wallet.bech32Address,
                name: params.name,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRemoveRateStrategy,
                value,
            }, opts);
        });
    }
    addAsset(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgAddAsset.fromPartial({
                creator: wallet.bech32Address,
                assetParams: {
                    denom: params.asset.denom,
                    oracleId: params.asset.oracleId,
                    rateStrategyName: params.asset.rateStrategyName,
                    loanToValue: params.asset.loanToValue.toString(10),
                    liquidationThreshold: params.asset.liquidationThreshold.toString(10),
                    liquidationDiscount: params.asset.liquidationDiscount.toString(10),
                    allowRepayStablecoinInterestDebt: params.asset.allowRepayStablecoinInterestDebt,
                    supplyCap: params.asset.supplyCap.toString(10),
                    borrowCap: params.asset.borrowCap.toString(10),
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgAddAsset,
                value,
            }, opts);
        });
    }
    updateAsset(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgUpdateAsset.fromPartial({
                creator: wallet.bech32Address,
                assetParams: {
                    denom: params.denom,
                    rateStrategyName: params.rateStrategyName,
                    allowRepayStablecoinInterestDebt: params.allowRepayStablecoinInterestDebt,
                    loanToValue: params.loanToValue.toString(10),
                    liquidationThreshold: params.liquidationThreshold.toString(10),
                    liquidationDiscount: params.liquidationDiscount.toString(10),
                    supplyCap: params.supplyCap.toString(10),
                    borrowCap: params.borrowCap.toString(10),
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateAsset,
                value,
            }, opts);
        });
    }
    setLiquidationFee(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgSetLiquidationFee.fromPartial({
                creator: wallet.bech32Address,
                liquidationFee: params.liquidationFee.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetLiquidationFee,
                value,
            }, opts);
        });
    }
    setInterestFee(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgSetInterestFee.fromPartial({
                creator: wallet.bech32Address,
                interestFee: params.interestFee.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetInterestFee,
                value,
            }, opts);
        });
    }
    setCompleteLiquidationThreshold(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgSetCompleteLiquidationThreshold.fromPartial({
                creator: wallet.bech32Address,
                completeLiquidationThreshold: params.completeLiquidationThreshold.shiftedBy(18).toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetCompleteLiquidationThreshold,
                value,
            }, opts);
        });
    }
    setMinimumCloseFactor(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgSetMinimumCloseFactor.fromPartial({
                creator: wallet.bech32Address,
                minimumCloseFactor: params.minimumCloseFactor.shiftedBy(18).toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetMinimumCloseFactor,
                value,
            }, opts);
        });
    }
    setSmallLiquidationSize(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Cdp.MsgSetSmallLiquidationSize.fromPartial({
                creator: wallet.bech32Address,
                smallLiquidationSize: params.smallLiquidationSize.shiftedBy(18).toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetSmallLiquidationSize,
                value,
            }, opts);
        });
    }
    createNewGroup(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgCreateGroup.fromPartial({
                creator: (_a = params.creator) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                name: params.name,
                chequeTokenSymbol: params.chequeTokenSymbol,
                oracleId: params.oracleId,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateGroup,
                value,
            }, opts);
        });
    }
    updateGroup(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgUpdateGroup.fromPartial({
                creator: (_a = params.creator) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                groupId: params.groupId,
                updateGroupParams: params.updateGroupParams,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateGroup,
                value,
            }, opts);
        });
    }
    registerToGroup(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgRegisterToGroup.fromPartial({
                creator: (_a = params.creator) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                groupId: params.groupId,
                denom: params.denom,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRegisterToGroup,
                value,
            }, opts);
        });
    }
    deregisterFromGroup(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgDeregisterFromGroup.fromPartial({
                creator: (_a = params.creator) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                groupId: params.groupId,
                denom: params.denom,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgDeregisterFromGroup,
                value,
            }, opts);
        });
    }
    updateGroupConfig(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = CarbonSDK_1.Carbon.Coin.MsgUpdateGroupedTokenConfig.fromPartial({
                creator: (_a = params.creator) !== null && _a !== void 0 ? _a : wallet.bech32Address,
                denom: params.denom,
                updateGroupedTokenConfigParams: params.updateGroupedTokenConfigParams,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateGroupedTokenConfig,
                value,
            }, opts);
        });
    }
}
exports.AdminModule = AdminModule;
function transfromCreateOracleParams(msg, address) {
    return {
        creator: address,
        id: msg.id,
        description: msg.description,
        minTurnoutPercentage: new long_1.default(msg.minTurnoutPercentage),
        maxResultAge: new long_1.default(msg.maxResultAge),
        securityType: msg.securityType,
        resultStrategy: msg.resultStrategy,
        resolution: new long_1.default(msg.resolution),
        spec: msg.spec,
    };
}
exports.transfromCreateOracleParams = transfromCreateOracleParams;
function transfromCreateTokenParams(msg, address) {
    return {
        creator: address,
        name: msg.name,
        symbol: msg.symbol,
        decimals: new long_1.default(msg.decimals),
        chainId: new long_1.default(msg.chainId),
        bridgeId: new long_1.default(msg.bridgeId),
        bridgeAddress: msg.bridgeAddress,
        tokenAddress: msg.tokenAddress,
    };
}
exports.transfromCreateTokenParams = transfromCreateTokenParams;
function transfromSyncTokenParams(msg, address) {
    return {
        syncer: address,
        denom: msg.denom,
    };
}
exports.transfromSyncTokenParams = transfromSyncTokenParams;
function transfromLinkPoolParams(msg) {
    return {
        poolId: new long_1.default(msg.poolId),
        market: msg.market,
    };
}
exports.transfromLinkPoolParams = transfromLinkPoolParams;
function transfromUnlinkPoolParams(msg) {
    return {
        poolId: new long_1.default(msg.poolId),
    };
}
exports.transfromUnlinkPoolParams = transfromUnlinkPoolParams;
function transfromSetRewardsWeightsParams(msg) {
    const weights = msg.map((param) => {
        return {
            poolId: new long_1.default(param.poolId),
            weight: param.weight.toString(10),
        };
    });
    return {
        weights: weights,
    };
}
exports.transfromSetRewardsWeightsParams = transfromSetRewardsWeightsParams;
function transfromSetRewardCurveParams(msg) {
    return {
        startTime: msg.startTime,
        initialRewardBps: msg.initialRewardBps,
        reductionMultiplierBps: msg.reductionMultiplierBps,
        reductionIntervalSeconds: new long_1.default(msg.reductionIntervalSeconds),
        reductions: msg.reductions,
        finalRewardBps: msg.finalRewardBps,
    };
}
exports.transfromSetRewardCurveParams = transfromSetRewardCurveParams;
function transfromSetCommitmentCurveParams(msg) {
    return {
        maxDuration: new long_1.default(msg.maxDuration),
        maxRewardMultiplier: msg.maxRewardMultiplier,
    };
}
exports.transfromSetCommitmentCurveParams = transfromSetCommitmentCurveParams;
function transfromUpdatePoolParams(msg) {
    return {
        poolId: new long_1.default(msg.poolId),
        numQuotes: new long_1.default(msg.numQuotes),
        swapFee: msg.swapFee.shiftedBy(18).toString(10),
    };
}
exports.transfromUpdatePoolParams = transfromUpdatePoolParams;
function transfromSetTradingFlagParams(msg, address) {
    return {
        creator: address,
        isEnabled: msg.isEnabled,
        blockchain: msg.blockchain,
    };
}
exports.transfromSetTradingFlagParams = transfromSetTradingFlagParams;
function transfromSetMsgGasCostParams(msg) {
    return {
        msgType: msg.msgType,
        gasCost: msg.gasCost.toString(10),
    };
}
exports.transfromSetMsgGasCostParams = transfromSetMsgGasCostParams;
function transfromSetMinGasPriceParams(msg) {
    return {
        denom: msg.denom,
        gasPrice: new bignumber_js_1.default(msg.gasPrice).shiftedBy(18).toString(10),
    };
}
exports.transfromSetMinGasPriceParams = transfromSetMinGasPriceParams;
function transformSetSettlementPriceParams(msg) {
    return {
        marketId: msg.marketId,
        settlementPrice: new bignumber_js_1.default(msg.settlementPrice).shiftedBy(18).toString(10),
    };
}
exports.transformSetSettlementPriceParams = transformSetSettlementPriceParams;
function transformCommunityPoolSpendAmount(amount) {
    const amounts = amount.map((param) => {
        return {
            denom: param.denom,
            amount: new bignumber_js_1.default(param.amount).toString(10),
        };
    });
    return amounts;
}
exports.transformCommunityPoolSpendAmount = transformCommunityPoolSpendAmount;
